module.exports = __webpack_public_path__ + "img/trinidad-and-tobago.59d68edc.svg";